module.exports = __webpack_public_path__ + "img/TECHNOLOGY_BG_pattern.76b85021.svg";